import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { IconButton, Tooltip } from '@mui/material';
import HeaderNotificationMenu from './HeaderNotificationMenu';

const LS_KEY = 'app_notifications_by_type';

function loadCount() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return 0;
    const obj = JSON.parse(raw);
    return Object.keys(obj).length;
  } catch { return 0; }
}

const audio = new Audio('../../../public/audio/new-notification-010-352755.mp3');

export default function NotificationRing() {
  const [count, setCount] = useState(loadCount());
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Escuchar evento personalizado para actualizar contador
  useEffect(() => {
    const handler = () => {
      const newCount = loadCount();
      if (newCount === 0) {
        return setCount(newCount);
      }
      setCount(newCount);
      // Emitir sonido de notificación cada vez que se actualice el contador
      audio?.play();
    };
    window.addEventListener('notifications_updated', handler);
    return () => window.removeEventListener('notifications_updated', handler);
  }, []);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Tooltip title={open ? "Cerrar notificaciones" : "Ver notificaciones"}>
        <IconButton
          onClick={handleOpen}
          sx={{
            color: 'white',
            p: { xs: 1, sm: 1.5 },
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.1)',
              transform: 'scale(1.05)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <Badge
            color="error"
            invisible={count === 0}
            badgeContent={count}
            max={99}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.65rem',
                height: '16px',
                minWidth: '16px',
                transform: 'scale(1) translate(50%, -50%)',
                transformOrigin: '100% 0%',
                right: '0px',
                top: '0px',
                animation: count > 0 ? 'pulse 2s infinite' : 'none',
                '@keyframes pulse': {
                  '0%': {
                    transform: 'scale(1) translate(50%, -50%)',
                  },
                  '50%': {
                    transform: 'scale(1.1) translate(50%, -50%)',
                  },
                  '100%': {
                    transform: 'scale(1) translate(50%, -50%)',
                  },
                }
              }
            }}
          >
            <NotificationsIcon
              sx={{
                fontSize: { xs: '22px', sm: '24px' },
                filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))'
              }}
            />
          </Badge>
        </IconButton>
      </Tooltip>
      <HeaderNotificationMenu anchorEl={anchorEl} open={open} onClose={handleClose} />
    </Box>
  );
}